declare namespace $ {

	export class $mol_link_support extends $mol_link {
		Icon( ): $mol_icon_face_agent
		hint( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=support.view.tree.d.ts.map